// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__8UvMD","modalForm":"UpgradeEpcsModal_modalForm__3aRmm","modalFooter":"UpgradeEpcsModal_modalFooter__lCHJo"};